//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseViewObject = require('@/tbs/model/vo/BaseViewObject')
const ClassFunc = require('@/tbs/util/ClassFunc')
const MatchSignupPayment = require('@/tbs/model/to/MatchSignupPayment')
const matchSignupPayment = new MatchSignupPayment
/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_MatchSignupConfig = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseViewObject, arguments)
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchSignupConfig.prototype = {
    /* The view object name */
    name: 'matchGroup',
    /* The view object instance */
    view: {
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchSignupSetting',
            query: {
                matchId: 'matchGroupId',
            },
            basePath: 'data',
            rule: {
                id: '$id',
                teamSignupItems: '$teamSignupSetting',
                memberSignupItems: '$playerSignupSetting',
                teamNumLabel: '$playerSignupLimit.teamMemberLeastCount,playerSignupLimit.teamMemberLimitCount,playerSignupLimit.playerCountASide',
                genderRestrictionLabel: '$playerSignupLimit.genderLimit',
                isGenderNumShow: '$playerSignupLimit.genderLimit',
                maleNumLabel: '$playerSignupLimit.maleMin,playerSignupLimit.maleMax,playerSignupLimit.teamMemberLimitCount',
                femaleNumLabel: '$playerSignupLimit.femaleMin,playerSignupLimit.femaleMax,playerSignupLimit.teamMemberLimitCount',
                ageRestrictionLabel: '$playerSignupLimit.maxAge,playerSignupLimit.minAge',
                isStaffOn: '@teamOfficerSignupSetting.required',
                staffNumLabel: '$teamOfficerSignupSetting.minCount,teamOfficerSignupSetting.maxCount',
                staffDutyItems: '$teamOfficerSignupSetting.roleFields',
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderId: function(id, options) {
        return options.parameters.matchId
    },
    renderTeamSignupItems: function(teamSignupSetting) {
        const items = []
        let item
        if (teamSignupSetting.name) {
            item = 1
            items.push({
                label: matchSignupPayment.localeProp('signup-team-config-type-' + item),
                value: item.toString()
            })
        }
        if (teamSignupSetting.teamAlias) {
            item = 2
            items.push({
                label: matchSignupPayment.localeProp('signup-team-config-type-' + item),
                value: item.toString()
            })
        }
        if (teamSignupSetting.contactPerson) {
            item = 3
            items.push({
                label: matchSignupPayment.localeProp('signup-team-config-type-' + item),
                value: item.toString()
            })
        }
        if (teamSignupSetting.contactNumber) {
            item = 4
            items.push({
                label: matchSignupPayment.localeProp('signup-team-config-type-' + item),
                value: item.toString()
            })
        }
        if (teamSignupSetting.badge) {
            item = 5
            items.push({
                label: matchSignupPayment.localeProp('signup-team-config-type-' + item),
                value: item.toString()
            })
        }
        if (teamSignupSetting.delegation && teamSignupSetting.teamDelegations) {
            item = 6
            items.push({
                label: matchSignupPayment.localeProp('signup-team-config-type-' + item),
                value: item.toString()
            })
        }
        if (teamSignupSetting.homeColor) {
            item = 7
            items.push({
                label: matchSignupPayment.localeProp('signup-team-config-type-' + item),
                value: item.toString()
            })
        }
        if (teamSignupSetting.awayColor) {
            item = 8
            items.push({
                label: matchSignupPayment.localeProp('signup-team-config-type-' + item),
                value: item.toString()
            })
        }
        if (teamSignupSetting.clothesColorDescription) {
            item = 9
            items.push({
                label: matchSignupPayment.localeProp('signup-team-config-type-' + item),
                value: item.toString()
            })
        }
        if (teamSignupSetting.insurancePolicy) {
            item = 11
            items.push({
                label: matchSignupPayment.localeProp('signup-team-config-type-' + item),
                value: item.toString()
            })
        }
        console.log('@renderTeamSignupItems', items)
        return items
    },
    renderMemberSignupItems: function(playerSignupSetting) {
        const items = []
        let item
        if (playerSignupSetting.trueName) {
            item = 1
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.number) {
            item = 2
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.mobile) {
            item = 3
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.gender) {
            item = 4
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.bmBirthday) {
            item = 5
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.IDCard && playerSignupSetting.certTypeFields) {
            item = 6
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.high) {
            item = 7
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.weight) {
            item = 8
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.jerseysSize) {
            item = 9
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.shoesSize) {
            item = 10
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.guardianName) {
            item = 11
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.guardianMobile) {
            item = 12
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.school) {
            item = 13
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.insureFile) {
            item = 14
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.position) {
            item = 15
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.qualificationFile) {
            item = 16
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.jerseyName) {
            item = 17
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.title) {
            item = 18
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.domicileAreaId) {
            item = 19
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.ethnicity) {
            item = 20
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.nationality) {
            item = 21
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.enterprise) {
            item = 22
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.post) {
            item = 23
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.joinTeam) {
            item = 24
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.serialNumber) {
            item = 25
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.isProfessionalPlayer) {
            item = 26
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.emergencyContactName) {
            item = 27
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        if (playerSignupSetting.remark) {
            item = 28
            items.push({
                label: matchSignupPayment.localeProp('signup-member-config-type-' + item),
                value: item.toString()
            })
        }
        return items
    },
    renderTeamNumLabel: function(teamMemberLeastCount, teamMemberLimitCount, playerCountASide) {
        teamMemberLeastCount = teamMemberLeastCount || 0
        teamMemberLimitCount = this._renderMaxNum(teamMemberLimitCount)
        teamMemberLeastCount = Math.max(teamMemberLeastCount, playerCountASide)
        return this.getPersonNumLabel(teamMemberLeastCount, teamMemberLimitCount)
    },
    renderGenderRestrictionLabel: function(genderLimit) {
        let genderRestriction = '1'
        if (genderLimit == 0) {
            genderRestriction = '4'
        }
        else if (genderLimit == 1) {
            genderRestriction = '2'
        }
        else if (genderLimit == 2) {
            genderRestriction = '3'
        }
        else if (genderLimit == 3) {
            genderRestriction = '1'
        }
        return matchSignupPayment.localeProp('gender-restriction-type-' + genderRestriction)
    },
    renderIsGenderNumShow: function(genderLimit) {
        return (genderLimit === 0)
    },
    renderMaleNumLabel: function(maleMin, maleMax, teamMemberLimitCount) {
        teamMemberLimitCount = this._renderMaxNum(teamMemberLimitCount)
        if (!maleMax && teamMemberLimitCount) {
            maleMax = teamMemberLimitCount
        }
        return this.getPersonNumLabel(maleMin, maleMax)
    },
    renderFemaleNumLabel: function(femaleMin, femaleMax, teamMemberLimitCount) {
        teamMemberLimitCount = this._renderMaxNum(teamMemberLimitCount)
        if (!femaleMax && teamMemberLimitCount) {
            femaleMax = teamMemberLimitCount
        }
        return this.getPersonNumLabel(femaleMin, femaleMax)
    },
    renderAgeRestrictionLabel: function(maxAge, minAge) {
        // console.log('@renderAgeRestrictionLabel', minAge, maxAge)
        const ageBirthMin = this._renderStartDate(maxAge)
        const ageBirthMax = this._renderEndDate(minAge)
        if (ageBirthMin && ageBirthMax) {
            const ageBirthMinArr = ageBirthMin.split('-')
            const ageBirthMaxArr = ageBirthMax.split('-')
            return matchSignupPayment.localeProp('birth-period', {
                fYear: ageBirthMinArr[0],
                fMonth: ageBirthMinArr[1],
                fDate: ageBirthMinArr[2],
                bYear: ageBirthMaxArr[0],
                bMonth: ageBirthMaxArr[1],
                bDate: ageBirthMaxArr[2],
            })
        }
        else if (ageBirthMin && !ageBirthMax) {
            const ageBirthMinArr = ageBirthMin.split('-')
            return matchSignupPayment.localeProp('birth-no-less', {
                year: ageBirthMinArr[0],
                month: ageBirthMinArr[1],
                date: ageBirthMinArr[2],
            })
        }
        else if (ageBirthMax && !ageBirthMin) {
            const ageBirthMaxArr = ageBirthMax.split('-')
            return matchSignupPayment.localeProp('birth-no-more', {
                year: ageBirthMaxArr[0],
                month: ageBirthMaxArr[1],
                date: ageBirthMaxArr[2],
            })
        }
        else if (!ageBirthMin && !ageBirthMax) {
            return matchSignupPayment.localeProp('no-limit')
        }
    },
    renderStaffNumLabel: function(minCount, maxCount) {
        return this.getPersonNumLabel(minCount, maxCount)
    },
    renderStaffDutyItems: function(roleFields) {
        roleFields = roleFields || ''
        return roleFields.split(',')
    },
    getPersonNumLabel: function(minNumber, maxNumber) {
        minNumber = minNumber || 0
        maxNumber = maxNumber || 0
        if (minNumber > 0 && maxNumber > 0) {
            if (minNumber < maxNumber) {
                return matchSignupPayment.localeProp('between-min-max', {min: minNumber, max: maxNumber, unit: '${person}'})
            }
            else if (minNumber == maxNumber) {
                return matchSignupPayment.localeProp('exact-num', {num: minNumber, unit: '${person}'})
            }
        }
        else if (minNumber > 0 && maxNumber == 0) {
            return matchSignupPayment.localeProp('no-less', {num: minNumber, unit: '${person}'})
        }
        else if (maxNumber > 0 && minNumber == 0) {
            return matchSignupPayment.localeProp('no-more', {num: maxNumber, unit: '${person}'})
        }
        else if (minNumber == 0 && maxNumber == 0) {
            return matchSignupPayment.localeProp('no-limit')
        }
    }
}

//--------------------------------------------------
// extends the BaseViewObject
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_MatchSignupConfig, BaseViewObject);

module.exports = tbs_model_vo_MatchSignupConfig